// Configuration de l'API
export const API_CONFIG = {
  // URL de base de l'API
  BASE_URL: process.env.REACT_APP_API_URL || '',

  // Endpoints d'authentification
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    VERIFY: '/api/auth/verify',
    // boubaker 22/08/2026 - IndexDB multi-utilisateurs
    IDXDB_RESET: '/api/auth/idxdb-reset',
    // SSO Endpoints
    SSO_PROVIDERS: '/api/auth/sso/providers',
    SSO_AUTHORIZE: '/api/auth/sso/authorize',
    SSO_EXCHANGE: '/api/auth/sso/exchange',
    SSO_SELECT_AGENCY: '/api/auth/sso/select-agency'
  },

  // Endpoints de monitoring
  MONITORING: {
    MAIN_DASHBOARD: '/api/dashboard/main',
    PERFORMANCE: '/api/dashboard/performance',
    OPTIMIZATION: '/api/dashboard/optimization',
    CHARTS: '/api/dashboard/charts'
  },

  // Endpoints BLOBTIC
  BLOBTIC: {
    ZOOM: '/api/blobtic/zoom'
  },

  // Endpoints de traçage du trafic API
  TRAFFIC: {
    DETAIL: '/api/TrafficLog/'
  },

  // Endpoints du journal des actions utilisateur
  USER_ACTION: {
    DETAIL: '/api/UserActionData/'
  },

  // Configuration des requêtes
  REQUEST: {
    TIMEOUT: 10000, // 10 secondes
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000
  }
};

// Fonctions utilitaires pour construire les URLs complètes
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const getAuthUrl = (endpoint: keyof typeof API_CONFIG.AUTH): string => {
  return buildApiUrl(API_CONFIG.AUTH[endpoint]);
};

export const getMonitoringUrl = (endpoint: keyof typeof API_CONFIG.MONITORING): string => {
  return buildApiUrl(API_CONFIG.MONITORING[endpoint]);
};

export const getBlobticUrl = (endpoint: keyof typeof API_CONFIG.BLOBTIC): string => {
  return buildApiUrl(API_CONFIG.BLOBTIC[endpoint]);
};
